
const state = {
  citecNoTeamSelected:false,
  citeCurrentDivision: 0,
  citeCurrentPlayerView:{},
  citecTeamsSelectedObject:[],
  citecTeamsSelectedPrimitive:[],
  citecTeamsSelectedAllPrimitive: [],
  citecCurrentMenu:'/news',
  citecCurrentJornada: {numero:1,abreviado:'J-1',nombre:'Jornada 1'},
  citecCurrentTorneo: { id: 1, name: 'Apertura 2020' }
}

const getters = {
  citeCurrentDivision: state => state.citeCurrentDivision,
  citecTeamsSelected: state => state.citecTeamsSelectedObject[state.citeCurrentDivision],
  citecTeamsSelectedPrimitive: state => state.citecTeamsSelectedPrimitive[state.citeCurrentDivision],
  citecTeamsSelectedAllPrimitive: state => state.citecTeamsSelectedAllPrimitive,
  citecCurrentMenu: state => state.citecCurrentMenu,
  citecCurrentJornada: state => state.citecCurrentJornada,
  citecCurrentTorneo: state => state.citecCurrentTorneo,
  citecNoTeamSelected: state => state.citecNoTeamSelected,
  citeCurrentPlayerView: state => state.citeCurrentPlayerView
}

const actions = {

  'DIVISION_SELECT': ({commit},idDivision) => {
    return new Promise((resolve) => {
      commit('SELECTED_DIVISION',idDivision)
      resolve()
    })
  },

  'CLUB_SELECT': ({commit},club) => {
    return new Promise((resolve) => {
      commit('SELECTED_CLUB',club)
      resolve()
    })
  },

  'CURRENT_PLAYER': ({ commit }, player) => {
    return new Promise((resolve) => {
      commit('CURRENT_PLAYER', player)
      resolve()
    })
  },


  'MENU_SELECTED': ({ commit }, menu) => {
    return new Promise((resolve) => {
      commit('MENU_SELECTED', menu)
      resolve()
    })
  },

  'SET_JORNADA': ({ commit }, jornada) => {
    return new Promise((resolve) => {
      commit('SET_JORNADA', jornada)
      resolve()
    })
  },

  'SET_TORNEO': ({ commit }, torneo) => {
    return new Promise((resolve) => {
      commit('SET_TORNEO', torneo)
      resolve()
    })
  },

  'NO_CLUB_SELECT': ({ commit }, condition) => {
    return new Promise((resolve) => {
      commit('NO_CLUB_SELECT', condition)
      resolve()
    })
  },
}

const mutations = {

  'SELECTED_DIVISION': (state, idDivision) => {
    state.citeCurrentDivision = idDivision
    if (state.citecTeamsSelectedPrimitive[state.citeCurrentDivision] == undefined) {
      state.citecTeamsSelectedPrimitive[state.citeCurrentDivision] = []
    }

    if (state.citecTeamsSelectedObject[state.citeCurrentDivision] == undefined) {
      state.citecTeamsSelectedObject[state.citeCurrentDivision] = []
    }
  },

  'MENU_SELECTED': (state, menu) => {
    state.citecCurrentMenu = menu
  },

  'SET_JORNADA': (state, jornada) => {
    state.citecCurrentJornada = jornada
  },

  'SET_TORNEO': (state, torneo) => {
    state.citecCurrentJornada = torneo
  },

  'CURRENT_PLAYER': (state, player) => {
    state.citeCurrentPlayerView = player
  },

  'SELECTED_CLUB': (state, club) => {

    const index = state.citecTeamsSelectedPrimitive[state.citeCurrentDivision].indexOf(club.idClub);
    let primitives = state.citecTeamsSelectedPrimitive[state.citeCurrentDivision]
    let allPrimitives = state.citecTeamsSelectedAllPrimitive
    let objects = state.citecTeamsSelectedObject[state.citeCurrentDivision]

    if (index > -1) {
      primitives.splice(index, 1)
      allPrimitives.splice(index, 1)
      
      objects.map((element, innerindex) => {
        if(element.idClub == club.idClub){
          objects.splice(innerindex, 1)
        }
      })
    }else{
      primitives.push(club.idClub)
      allPrimitives.push(club.idClub)
      objects.push(club)
    }
    
    state.citecTeamsSelectedPrimitive[state.citeCurrentDivision] = primitives
    state.citecTeamsSelectedObject[state.citeCurrentDivision] = objects
    state.citecTeamsSelectedAllPrimitive = allPrimitives
  },

  'NO_CLUB_SELECT': (state, condition) => {
    state.citecNoTeamSelected = condition
  },

}

export default {
  state,
  getters,
  actions,
  mutations,
}
